import React, { useId } from 'react';
import PropTypes from 'prop-types';
import './LiveGameVideoStage.css';

/**
 * Figma 17742:25757 arched video frame — curves inverted (opposite direction).
 * viewBox 960.138 × 521.994
 */
const ARCH_PATH =
  'M0 495.5543C0 506.0827 0 511.3469 2.12927 514.90444C4.01374 518.05294 6.89886 520.34762 10.3907 521.475171C14.3361 522.749192 19.4842 521.560089 29.7805 519.18188C108.92 500.9024 328.738 453.499 480.069 453.499C631.401 453.499 851.218 500.9024 930.358 519.18188C940.654 521.560089 945.802 522.749192 949.748 521.475171C953.24 520.34762 956.125 518.05294 958.009 514.90444C960.138 511.3469 960.138 506.0827 960.138 495.5543V91.502C960.138 84.824 960.138 81.484 958.945 78.674C957.901 76.218 956.169 74.029 954.019 72.449C951.558 70.641 948.383 69.892 942.035 68.393C875.557 52.695 640.452 0 480.069 0C319.686 0 84.5811 52.695 18.1038 68.393C11.7552 69.892 8.58084 70.641 6.11977 72.449C3.96934 74.029 2.23707 76.218 1.19388 78.674C0 81.484 0 84.824 0 91.502V495.5543Z';

/** Normalized objectBoundingBox path for CSS clip-path (vertically flipped) */
const ARCH_CLIP_PATH =
  'M0 0.949349C0 0.969518 0 0.979603 0.002218 0.986418C0.00418 0.99245 0.007185 0.996846 0.010822 0.999006C0.014931 1.001447 0.020293 0.999169 0.031017 0.994613C0.113442 0.959594 0.342386 0.868782 0.5 0.868782C0.657615 0.868782 0.886558 0.959594 0.968984 0.994613C0.979707 0.999169 0.985069 1.001447 0.989179 0.999006C0.992816 0.996846 0.99582 0.99245 0.997783 0.986418C1 0.979603 1 0.969518 1 0.949349V0.175293C1 0.1625 1 0.156101 0.998757 0.150718C0.99767 0.146013 0.995866 0.14182 0.993627 0.138793C0.991064 0.135329 0.987757 0.133894 0.981145 0.131023C0.911907 0.100949 0.667042 0 0.5 0C0.332958 0 0.088093 0.100949 0.018855 0.131023C0.012243 0.133894 0.008937 0.135329 0.006374 0.138793C0.004134 0.14182 0.00233 0.146013 0.001243 0.150718C0 0.156101 0 0.1625 0 0.175293V0.949349Z';

/**
 * Arched video stage — inverted curves; counter on bottom upward arch.
 */
const LiveGameVideoStage = ({ children, overlay }) => {
  const clipId = useId().replace(/:/g, '');
  const clipUrl = `live-game-video-arch-clip-${clipId}`;

  return (
    <div className="live-game-video-stage" data-node-id="17742:25757">
      <svg width={0} height={0} aria-hidden="true" focusable="false">
        <defs>
          <clipPath id={clipUrl} clipPathUnits="objectBoundingBox">
            <path d={ARCH_CLIP_PATH} />
          </clipPath>
        </defs>
      </svg>

      <div className="live-game-video-stage__frame">
        <svg
          className="live-game-video-stage__border"
          viewBox="0 0 960.138 521.994"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            d={ARCH_PATH}
            fill="none"
            stroke="#FF00F2"
            strokeWidth="6"
            vectorEffect="non-scaling-stroke"
          />
        </svg>

        <div
          className="live-game-video-stage__media"
          style={{
            clipPath: `url(#${clipUrl})`,
            WebkitClipPath: `url(#${clipUrl})`,
          }}
        >
          {children}
        </div>
      </div>

      {overlay ? <div className="live-game-video-stage__overlay">{overlay}</div> : null}
    </div>
  );
};

LiveGameVideoStage.propTypes = {
  children: PropTypes.node,
  overlay: PropTypes.node,
};

export default LiveGameVideoStage;
